/**
 * Whether the signed-in person carries the support flag for the time-based timeline.
 *
 * Kept free of React imports so it can be unit-tested directly, the way patientViewRouting is.
 *
 * @param flagsJson the raw `featureFlags.flags` string off the person's own profile - not the
 * merged result of useFeatureFlags. See useMiniTimelineThemes for why it is read from there.
 */
export const SUPPORT_FLAG_KEY = 'timeBasedMiniTimelineSupport'

export default (flagsJson = '{}') => {
  try {
    // A stored "null" parses to null, which would throw on the property access rather than on the
    // parse - so the access belongs inside the try as well.
    return !!JSON.parse(flagsJson || '{}')[SUPPORT_FLAG_KEY]
  } catch {
    return false
  }
}
